import DialogContent from "@mui/material/DialogContent";
import { DialogActions, useTheme } from "@mui/material";
import { ModalTitle, ModalMessage, ModalButton, ModalErrorText, ModalWarningText } from "../DialogModalComponents";
import { EventModalTypes, DialogModalStyles } from "../DialogModalWrapper";

interface ISplitPairing {
  isOpen: boolean;
  handleClose: (value: boolean) => void;
  setActiveEventModal: (EventModalTypes: EventModalTypes) => void;
  modalProps: {
    title?: string;
    message?: string;
  };
}

/**
 *  Modal to warn user/planner that they have unawarded assigned bids
 */
export const BidAssignmentDirty = (props: ISplitPairing): JSX.Element => {
  const { isOpen, handleClose, setActiveEventModal, modalProps } = props;
  const theme = useTheme();
  const handleCancel = (): void => {
    //cancel modal
    handleClose(false);
    setActiveEventModal(EventModalTypes.None);
  };

  if (isOpen) {
    return (
      <DialogContent sx={DialogModalStyles(theme)}>
        <div className="modal_content" style={{ display: "flex", maxWidth: 500 }}>
          <ModalTitle title={modalProps?.title ?? "Bid Assignments have pending changes!"} />
          <ModalMessage message={modalProps?.message ?? "Please save pending changes before switching crew members."} />
          <DialogActions>
            <ModalButton label="Cancel" handler={handleCancel}></ModalButton>
          </DialogActions>
        </div>
      </DialogContent>
    );
  } else {
    return null;
  }
};
